import React, { createContext } from 'react';
import { Provider } from 'react-redux';
import ActionCable from 'actioncable';

import configureStore from '../store/confirmShowStore';
import ConfirmShowContainer from '../containers/ConfirmShowContainer';

const CableApp = {};
CableApp.cable = ActionCable.createConsumer('/cable');
const ActionCableContext = createContext();

const ConfirmShowApp = (props) => (
  <Provider store={configureStore(props)}>
    <ActionCableContext.Provider value={CableApp}>
      <ConfirmShowContainer />
    </ActionCableContext.Provider>
  </Provider>
);

export default ConfirmShowApp;
export { ActionCableContext };
